import styled, {css} from 'styled-components'
import {Dropzone} from '@components/ui/dropzone/Dropzone.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledGalleryDropzone = styled(Dropzone)(
    ({theme: {palette}}) => css`
        width: 100%;
        height: 360px;
        border-radius: 16px;
        border: 1px dashed ${palette.neutral[300]};
    `
)

export const StyledGalleryTrigger = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        height: 100%;

        & svg {
            color: ${palette.neutral[600]};
        }
        & h3 {
            ${typography.textMd};
            font-weight: 500;
            color: ${palette.neutral[900]};
        }
    `
)

export const StyledGalleryGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: ${spacing * 5}px;
    `
)
